import EngagementsDemoPage from 'app/PoC/DataGridDemoPages/EngagementsDemo/EngagementsDemoPage'
import {
    createSkyNetDomainRoutes,
} from 'app/PoC/DataGridDemoPages/SkyNetDomainV2/SkyNetDomain.utils'
import domainConfig from './EngagementsDemo.config'

export default createSkyNetDomainRoutes(<EngagementsDemoPage />, domainConfig)
